/* Each badge opens the reviews for its own product, including switched homepage offers. */
if (!window.lundraReviewLinksInstalled) {
  window.lundraReviewLinksInstalled = true;
  document.addEventListener('click', function (event) {
    const badge = event.target.closest('.lu-rating .jdgm-preview-badge');
    if (!badge || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    const wrapper = badge.closest('[data-lu-review-target]');
    if (!wrapper) return;
    event.preventDefault();
    event.stopPropagation();
    window.location.assign(wrapper.dataset.luReviewTarget);
  }, true);
}
